import { call } from "store/api";
import { ConversationInfoItem } from "store/chat-types";

export const getConversation = async (conversationId: string): Promise<ConversationInfoItem> => {
    return await call("GET", `/messaging/v1/conversations/${conversationId}`);
};
